import { ShowingsListDelegate } from '../../../services/DataDelegate/ShowingsDelegate/showings.list.delegate';

export namespace ShowingsStates {
    export function showingsStatesFactory() {
        const showings = {
            list: { timestamp: new Date(), data: [], total: 100, currentPage: 1 },
            isFetching: false,
            // agentAuto: { timestamp: new Date(), data: [] },
        };
        return showings;
    }

    export function mutations() {
        return {
            updateShowings(state: any) {
                const delegate = new ShowingsListDelegate();
                const data: any = delegate.Data;
                state.showings.list.data = data;
                state.showings.list.currentPage = delegate.CurrentPage;
                state.showings.list.total = delegate.TotalItems;
                state.showings.list.timestamp = new Date();
            },
            showingStartFetching(state: any) {
                state.showings.isFetching = true;
            },
            showingEndFetching(state: any) {
                state.showings.isFetching = false;
            },
            // showingGetAgentAutoMatch(state) {
            //   console.log('Matching Agents---------------------------');
            //   const data: any = new ShowingsAgentAutoDelegate().Data;
            //   state.showings.agentAuto.data = data;
            //   state.showings.agentAuto.timestamp = new Date();
            // },
        };
    }
}
